<form [formGroup]="addOrEditForm" class="tablelist-form" autocomplete="off">
  <label for="typeAlertID-field" class="form-label">Alert Type</label>
  <select #typeAlertSelect class="form-select" name="typeAlertID-field" id="typeAlertID-field" formControlName="typeAlertID" (change)="selectOnChange($event, typeAlertSelect.options.selectedIndex==undefined ? undefined : typeAlertSelect.options[typeAlertSelect.options.selectedIndex].text)">
    <option selected>{{firstTypeAlertOption}}</option>
    @for (object of getDropdownDataObjectArray(); track object.id) {
      <option [ngValue]="object.id">{{object.description}}</option>    
    }
  </select>
</form>
